/**
 * Wear parts front end
 */

document.addEventListener('facetwp-loaded', function() {

  // Disable models filterin in first phase
  fUtil('.facetwp-facet-models .facetwp-checkbox').addClass('disabled');

  const filterItems = document.querySelectorAll('.filter-item');

  filterItems.forEach(function(filterItem) {
    // const checkboxesContainer = filterItem.querySelector('.filter-item__subtypes, .filter-item__models');
    const loadMoreBtn = filterItem.querySelector('.filter-item-load-more');

    // Hide button by default
    if(loadMoreBtn) {
      loadMoreBtn.style.display = 'none';
    }

    const checkboxesContainer = filterItem.querySelector('.facetwp-facet-models');
    // Check container height and add maxHeight and show button if needed
    if(checkboxesContainer && checkboxesContainer.offsetHeight > 169) {
      checkboxesContainer.style.maxHeight = '170px';
      loadMoreBtn.style.display = 'block';
    }

    if (!loadMoreBtn) {
      // console.error('Load More button not found for filter item:', filterItem);
      return; // Skip this filter item if the Load More button is not found
    }

    loadMoreBtn.addEventListener('click', function() {
      // Remove max-height and overflow property
      checkboxesContainer.style.maxHeight = 'none';
      checkboxesContainer.style.overflow = 'visible';
      // Hide the Load More button
      loadMoreBtn.style.display = 'none';
    });
  });

});
